module.exports = __webpack_public_path__ + "static/media/binance-coin-logo.20b8c2c4.webp";